import React from 'react';
import classNames from 'classnames';

import {
  HEADER_OFFSET,
  BAR_TOP,
  BAR_HEIGHT,
  GAP_UNDER_BAR,
} from 'helpers/utils/components/constants';

import type { SnappingRect } from 'helpers/utils/components/snapping-bar';

export interface DimMasksProps {
  rect: SnappingRect;
}

const DimMasks: React.FC<DimMasksProps> = ({ rect }) => {
  const overlayStyle = 'fixed bg-black/60 pointer-events-none z-[700]';
  const lineStyle = 'fixed z-[701] pointer-events-none bg-white';

  const viewportBottom =
    window.innerHeight || document.documentElement.clientHeight || 0;

  const clampTop = Math.max(
    HEADER_OFFSET,
    BAR_TOP + BAR_HEIGHT + GAP_UNDER_BAR,
  );
  const visibleTop = Math.max(0, Math.max(rect.top, clampTop));
  const visibleBottom = Math.min(rect.bottom, viewportBottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);
  const hasVisibleSlice = visibleHeight > 0;

  return (
    <>
      <div
        className={classNames(overlayStyle, 'top-0 left-0 w-screen')}
        style={{
          height: Math.max(0, visibleTop),
        }}
      />

      <div
        className={classNames(overlayStyle, 'left-0')}
        style={{
          top: visibleTop,
          width: Math.max(0, rect.left),
          height: visibleHeight,
        }}
      />
      <div
        className={overlayStyle}
        style={{
          top: visibleTop,
          left: rect.right,
          width: `calc(100vw - ${rect.right}px)`,
          height: visibleHeight,
        }}
      />

      <div
        className={classNames(overlayStyle, 'left-0 w-screen')}
        style={{
          top: visibleBottom,
          height: `calc(100vh - ${visibleBottom}px)`,
        }}
      />

      {hasVisibleSlice && (
        <>
          <div
            className={classNames(lineStyle, 'w-1')}
            style={{
              top: visibleTop,
              left: rect.left - 2,
              height: visibleHeight,
            }}
          />
          <div
            className={classNames(lineStyle, 'w-1')}
            style={{
              top: visibleTop,
              left: rect.right,
              height: visibleHeight,
            }}
          />
          {rect.top >= clampTop &&
            rect.top >= 0 &&
            rect.top <= viewportBottom && (
              <div
                className={classNames(lineStyle, 'h-0.5')}
                style={{
                  top: rect.top,
                  left: rect.left - 2,
                  width: rect.width,
                }}
              />
            )}
          {rect.bottom <= viewportBottom && rect.bottom >= HEADER_OFFSET && (
            <div
              className={classNames(lineStyle, 'h-0.5')}
              style={{
                top: rect.bottom - 1,
                left: rect.left - 2,
                width: rect.width,
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default DimMasks;
